import { classNames } from "../../utils";

export default function Badge({
  children,
  color,
  className,
  onClick,
}: {
  children: React.ReactNode;
  color?: "blue" | "red" | "green" | "yellow" | "gray";
  className?: string;
  onClick?: () => void;
}) {
  return (
    <span
      className={classNames(
        "rounded-md whitespace-nowrap mt-0.5 px-1.5 py-0.5 text-xs font-semibold ring-1 ring-inset ring-black/20",
        color === "green" && "text-green-700 bg-green-50 ring-green-600/20",
        color === "red" && "text-red-700 bg-red-50 ring-red-600/20",
        color === "blue" && "text-blue-800 bg-blue-50 ring-blue-600/20",
        color === "yellow" && "text-yellow-800 bg-yellow-100 ring-yellow-600/40",
        color === "gray" && "text-gray-700 bg-gray-50 ring-gray-600/20",
        onClick && "cursor-pointer",
        className,
      )}
      onClick={onClick}
    >
      {children}
    </span>
  );
}
